/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.conference.component.rpc.ui.service.v1.WebinarsChirpUIService
 */

export const getWebinarsRpc = {
  serviceName: 'com.hubspot.video.conference.component.rpc.ui.service.v1.WebinarsChirpUIService',
  rpcName: 'getWebinars',
  auth: 'app',
  fingerprint: 'HCM0FVsdqMaq2yIiE2cYVqyQTP9i5qss'
};